export function formatNumber(number: number): string {
  return new Intl.NumberFormat(window.appSettings.localeFormat).format(number);
}
